import { useEffect, useState } from 'react';
import { Text, Icon, Label, PrimaryButton, Dropdown, ISelectableOption } from '@fluentui/react';
import TimeTaxSupportSystemClient from '../../../../../system';
import { DateTime } from 'luxon';
import MessageCourier from '../../../../../lib/MessageCourier';
import { getLocalizedStrings } from '../../../../../lib/LocalizedStringsForDatePicker';
import CustomDatePicker from '../../../../../lib/CustomDatePicker';
import { t } from 'i18next';
import { LiquidacionInsumo } from '../../../../../system/settlement/aje/liquidacion-insumos';
import { AgrupadorCorporacionLiquidadora } from '../../../../../system/agrupador_corporacion_liquidadora/AgrupadorCorporacionLiquidadoraSystem';
import { UseAgrupadorCorporacionLiquidadoraListResult } from '../../../../../shared/hooks/useAgrupadorCorporacionLiquidadoraList';

interface IProjectConfiguration {
  setButtonDisability: (can: boolean) => void;
  system: TimeTaxSupportSystemClient;
  getDataFromCompanySelectorAssistant: (month: DateTime) => void;
  courier: MessageCourier;
  liquidacionInsumosList: LiquidacionInsumo[];
  hasItems: boolean | null;
  month: DateTime;
  lastSettlement: String | undefined;
  setSettlementType: React.Dispatch<React.SetStateAction<ISelectableOption<AgrupadorCorporacionLiquidadora>>>;
  settlementType: ISelectableOption<AgrupadorCorporacionLiquidadora>;
  agrupadoresCorporacionLiquidadora: UseAgrupadorCorporacionLiquidadoraListResult;
}

const SettlementPeriod = (props: IProjectConfiguration) => {
  const [minDate2, setMinDate] = useState<Date | Date>(new Date());
  const [month, setMonth] = useState<DateTime>();

  useEffect(() => {
    if (month) {
      props.getDataFromCompanySelectorAssistant(month);
    }

    if (!props.hasItems) {
      props.setButtonDisability(false);
    }
    if (props.hasItems) {
      props.setButtonDisability(true);
    }
  }, [month, props, props.hasItems]);

  useEffect(() => {
    props.system
      .configuration()
      .then((dato) => {
        if (dato) {
          const dt = dato.getActivitiesBlocked();
          if (dt) {
            setMinDate(dt.toJSDate());
          } else {
            setMinDate(new Date());
          }
        }
      })
      .catch((error) => {
        console.error('Error al obtener la configuración del sistema:', error);
        setMinDate(new Date());
      });
  }, [props.system]);

  const onChangeDate = (date: Date | null | undefined, name: string) => {
    if (date) {
      setMonth(DateTime.fromJSDate(date));
    }
  };

  const getLastMonth = () => {
    if (props.lastSettlement) {
      const blockedDates: { [key: number]: number[] } = {};
      const dates = props.lastSettlement.split('|');

      dates.forEach((dateStr) => {
        const [year, month] = dateStr.split('-').map(Number);
        if (!blockedDates[year]) {
          blockedDates[year] = [];
        }
        blockedDates[year].push(month);
      });

      return blockedDates;
    }
    return {};
  };
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);

  const onSelectDate = (date: Date | null | undefined) => {
    setIsDatePickerOpen(false);
    if (date) {
      onChangeDate(date, 'from');
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const datePicker = document.querySelector('.ms-DatePicker');
      if (datePicker && !datePicker.contains(event.target as Node)) {
        if (isDatePickerOpen) {
          setIsDatePickerOpen(false);
          console.log('El DatePicker se ha cerrado');
        }
      }
    };

    if (isDatePickerOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDatePickerOpen]);

  return (
    <div>
      <div>
        <Text variant="smallPlus">
          <Icon iconName="Info" className="text-icon-small"></Icon>
          {t('Para la liquidación de asesorías se bloqueará la carga en el periodo seleccionado de manera automática.')}
        </Text>
      </div>
      <div className="ms-Grid mt-2" dir="ltr">
        <div className="ms-Grid-row ">
          <div className="ms-Grid-col ms-sm3 ">
            {getLastMonth() ? (
              <CustomDatePicker
                strings={getLocalizedStrings()}
                label={t('Mes a liquidar')}
                value={props.month.toJSDate()}
                minDate={minDate2}
                blockedMonths={getLastMonth()}
                onSelectDate={onSelectDate}
              />
            ) : null}
          </div>
          {/* {getLastMonth() ? (
            <div className="ms-Grid-col ms-sm3 ">
              <Label className="invisible">{t('Buscar')}</Label>
              <PrimaryButton
                text={t('Buscar')}
                onClick={() => props.getPreliquidacionReport()}
                disabled={props.settlementType.key === ''}
              ></PrimaryButton>
            </div>
          ) : null} */}
        </div>
        <div className="ms-Grid-row mt-2 mb-2">
          <div className="ms-Grid-col ms-sm3 ">
            <Dropdown
              label={t('Tipo de liquidación')}
              placeholder={t('Seleccione el tipo de liquidación')}
              options={props.agrupadoresCorporacionLiquidadora.data.map((a) => ({ key: a.agrcorliq_id, text: a.agrcorliq_nombre, data: a }))}
              disabled={props.agrupadoresCorporacionLiquidadora.loading}
              selectedKey={props.settlementType.key}
              onChange={(e, option) => {
                if (!option) return;
                props.setSettlementType(option);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettlementPeriod;
